// <auto-generated/>
// Contents of: hl7.fhir.r4.core version: 4.0.1
  // Primitive Naming Style: None
  // Complex Type / Resource Naming Style: PascalCase
  // Interaction Naming Style: None
  // Extension Support: NonPrimitive
  // Restricted to: Patient|Encounter|Questionnaire|QuestionnaireResponse|Observation|GuidanceResponse|CarePlan|ServiceRequest|Parameters|OperationOutcome
  // Language option: "namespaceRoot" = "IntgelligentNav.Fhir"
  // Language option: "partialClasses" = "true"
  // Language option: "systemTextJson" = "true"
  // Language option: "tolerantEnums" = "true"
  // Language option: "singleFile" = "false"
// Minimum TypeScript Version: 3.7
import * as fhir from '../fhir'
/**
 * A relationship of two Quantity values - expressed as a numerator and a denominator.
 */
export type IRatio = fhir.IFhirElement & {
  /**
   * The value of the denominator.
   */
  denominator?: fhir.IQuantity|undefined;
  /**
   * The value of the numerator.
   */
  numerator?: fhir.IQuantity|undefined;
}
/**
 * A relationship of two Quantity values - expressed as a numerator and a denominator.
 */
export class Ratio extends fhir.FhirElement implements fhir.IRatio {
  /**
   * The value of the denominator.
   */
  public denominator?: fhir.Quantity|undefined;
  /**
   * The value of the numerator.
   */
  public numerator?: fhir.Quantity|undefined;
  /**
   * Default constructor for Ratio - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.IRatio> = {}) {
    super(source);
    if (source["denominator"]) { this.denominator = new fhir.Quantity(source.denominator!); }
    if (source["numerator"]) { this.numerator = new fhir.Quantity(source.numerator!); }
  }
  /**
   * Check if the current Ratio contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a Ratio from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.IRatio):Ratio {
    var dest:Ratio = new Ratio(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `Ratio is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
